import { Offcanvas } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { useGetUserInfoQuery } from '@/app/common/api/authApi';
import CardSkeleton from '@/app/common/components/skeleton/CardSkeleton';
import LineTimeChart from '@/app/common/components/LineTimeChart';
import { getColor } from '@/helpers/utils';
import { useGetAvgRanksChartQuery } from '@/app/KeywordTracker/api/keywordsApi';
import { useSearchParams } from 'react-router-dom';
import useDomain from '@/hooks/useDomain';
const AvgRankListDrawer = ({ show, setShow }) => {
  // const [isDotsAllowed, setIsDotsAllowed] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams();
  const { data: userInfo } = useGetUserInfoQuery();
  const { domain_slug, domain } = useDomain();
  const { data: chartData, isFetching } = useGetAvgRanksChartQuery(
    {
      domain_slug,
      from_date: Number(searchParams.get('from_date')),
      to_date: Number(searchParams.get('to_date'))
    },
    { skip: !domain_slug || !show }
  );
  return (
    <Offcanvas
      onShow={() => {
        const offcanvasElement = document.querySelector('.offcanvas');
        if (offcanvasElement) {
          offcanvasElement.removeAttribute('tabindex');
        }
      }}
      show={show}
      onHide={() => {
        setShow(false);
      }}
      style={{ backgroundColor: 'var(--falcon-body-bg)' }}
    >
      <Offcanvas.Header closeButton>
        <Offcanvas.Title>
          <div className="d-flex flex-wrap gap-3 align-items-center">
            <h6 className="m-0 fw-light">
              نمودار میانگین رتبه کلمات کلیدی &nbsp;
            </h6>
          </div>
        </Offcanvas.Title>
      </Offcanvas.Header>
      <hr className="my-0" />
      <Offcanvas.Body className="pb-5 pt-0">
        {/* <div className="d-flex gap-2 align-items-center">
          <h5 className="fs-0">نمایش نقطه ها </h5>
          <Form.Check
            type="switch"
            id="fluid-mode-switch"
            checked={isDotsAllowed}
            onChange={({ target }) => setIsDotsAllowed(target.checked)}
          />
        </div> */}
        {!isFetching && chartData ? (
          <LineTimeChart
            isFullDate
            isInversed
            topLabel="میانگین رتبه"
            dates={
              chartData ? chartData?.data.average_position.update_dates : []
            }
            series={
              chartData
                ? [
                    {
                      name: 'نمودار میانگین رتبه کلمات کلیدی',
                      data: chartData?.data.average_position.average_rank,
                      color: getColor(
                        'navbar-vertical-default-link-active-color'
                      )
                    }
                  ]
                : []
            }
          />
        ) : (
          <CardSkeleton />
        )}
        {/* {data && (
            <CtrChart
              setViewChartMode={setViewChartMode}
              viewChartMode={viewChartMode}
              data={(viewChartMode === 'desktop' ? desktop : mobile)
                .map((num, i) => ({
                  value: num,
                  itemStyle: {
                    color: colorByIndex(i),
                    borderRadius: [0, 3, 3, 0]
                  }
                }))
                .reverse()}
            />
          )} */}
      </Offcanvas.Body>
      <style>
        {/* استایل کلی دراور */}
        {`
 .offcanvas{
     width:1300px !important;
      max-width:100% !important;
    }
  .offcanvas img {
    margin: 0 auto;
    max-width: 100%;
    height: auto;
    display: flex;
    }
 `}
      </style>
    </Offcanvas>
  );
};

export default AvgRankListDrawer;
